import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Button';
import { Dialog } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  subtitle: string;
  confirmText: string;
}

export default function ConfirmationDialog({
  open,
  onClose,
  onConfirm,
  subtitle,
  confirmText,
}: ConfirmationDialogProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'posPreview',
  });

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      title="Are you sure?"
      subtitle="This action cannot be undone."
    >
      <Stack spacing={2}>
        <Typography variant="body1">{subtitle}</Typography>

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="text" onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button variant="contained" color="error" onClick={handleConfirm}>
            {confirmText}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}
